import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SHARED_MODULES } from '../../../shared.';
import { PhIconComponent } from '../ph-icon/ph-icon.component';

@Component({
    selector: 'ph-link-button',
    templateUrl: 'ph-link-button.component.html',
    styleUrls: ['ph-link-button.component.scss'],
	imports: [SHARED_MODULES, PhIconComponent],
    standalone: true
})
export class PhLinkButtonComponent {

	@Input() id: string;
	@Input() icon: string;
	@Input() title: string;
	@Input() description: string;

	@Output('buttonClick') clickEmitter: EventEmitter<Event> = new EventEmitter<Event>();

	constructor() {}
}
